import { useEffect, useRef, useState, forwardRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import ColorBox from "./ColorBox";
import { LoadingSvg } from "../../icons/Icon";
import { Loading } from "../Loaders";
import Input from "../components/Input";
import { iconsMap } from "../../icons/iconsMap";
import { useEventContext } from "../../contexts/EventContextProvider";
import { cancelTagCrudFromEvent, saveTagCrudFromEvent, deleteTagEvent } from "../../events/TagEvents";
import { $serializeForm } from "../../main";

const TagInputBar = forwardRef((p, r) => {

    const { state, eventDispatch } = useEventContext();
    const dispatch = useDispatch();
    const allTags = useSelector((state) => state.base.tags);
    const form = useRef(null);

    const actionClass = {
        edit: 'CollectionInputBar_controls_edit',
        save: 'CollectionInputBar_controls_edit',
        create: 'CollectionInputBar_controls_create',
        delete: 'CollectionInputBar_controls_delete',
    };
    //useEffect(() => console.log(p.edit), [p.edit]);
    const onCancel = (e) => {
        eventDispatch(cancelTagCrudFromEvent());
    };
    const onSave = (e) => {
        const [encoded, json] = $serializeForm(form.current);
        const type = state?.tagCreateEditDelete?.meta?.type;
        if(type == 'delete'){
            eventDispatch(deleteTagEvent(json, dispatch, allTags));
        }else{
            eventDispatch(saveTagCrudFromEvent(json, dispatch, allTags));
        }
    };
    const render = (p, m) => (
        <div ref={r} className="CollectionInputBar">
            <div className="CollectionInputBar_header">
                <h6 className="CollectionInputBar_title">
                    {iconsMap[m.type]}<span>{m.title}</span>
                    <em>{p?.name || ''}</em>
                </h6>
                <div className="CollectionInputBar_controls">
                    <button onClick={onCancel} className="CollectionInputBar_controls_cancel">cancel</button>
                    {(m?.button) ?
                        <button onClick={onSave} className={actionClass[m?.type]} >{m?.button}</button> :
                        <></>}
                </div>
            </div>
            <form ref={form}>
                <div className="CollectionInputBar_body">
                    <div className="flex-row">
                        <input type="hidden" name="id" value={p?.id || ''} />
                        <div className="col-6">
                            <Input label={'name'} value={`${p?.name || ''}`} placeholder={'name'} />
                        </div>
                        <div className="col-12">
                            <Input label={'description'} value={`${p?.description || ''}`} placeholder={'description'} />
                        </div>
                        <div className="col-6">
                            <ColorBox value={`${p?.color || ''}`} />
                        </div>
                    </div>
                </div>
            </form>
        </div>
    );
    const renderCase = (state, render) => {
        switch (state?.status) {
            case 'LOADING':
                return <Loading><LoadingSvg /></Loading>;
            case 'DONE':
                console.log('renderCase.done', state);
                return render(state.payload, state.meta);
            case 'ERROR':
                return <></>;
            default:
                return <></>;
        }
    }
    return renderCase(state.tagCreateEditDelete, render);
});

export default TagInputBar;